interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

const cache = new Map<string, CacheEntry<unknown>>();

const DEFAULT_TTL_MS = 30_000;
const STABLE_TTL_MS = 5 * 60_000;

const STABLE_TABLES = new Set([
  'org_config',
  'vendor_intelligence',
  'territory_plans',
  'org_license',
  'ai_prompt_configs',
]);

function getTTL(table: string): number {
  return STABLE_TABLES.has(table) ? STABLE_TTL_MS : DEFAULT_TTL_MS;
}

export function getCached<T>(key: string): T | null {
  const entry = cache.get(key);
  if (!entry) return null;
  const table = key.split(':')[0] || '';
  const ttl = getTTL(table);
  if (Date.now() - entry.timestamp > ttl) {
    cache.delete(key);
    return null;
  }
  return entry.data as T;
}

export function setCache<T>(key: string, data: T): void {
  cache.set(key, { data, timestamp: Date.now() });
}

export function invalidateCache(prefix: string): void {
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) {
      cache.delete(key);
    }
  }
}

export function clearCache(): void {
  cache.clear();
}
